import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface UpdateSellerDaqiEditingDuringSuspensionArg {
    engagementId: number;
    isEnabled: boolean;
}

export const UpdateSellerDaqiEditingDuringSuspension = createAsyncThunk(
    'timelines/updateSellerDaqiEditingDuringSuspension',
    async (arg: UpdateSellerDaqiEditingDuringSuspensionArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/Engagements/${arg.engagementId}/DataRequests/sellerEditingDuringSuspension`,
                arg.isEnabled,
                {
                    headers: { 'Content-Type': 'application/json' },
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to update the seller DaQI editing setting');
            }

            return { isEnabled: arg.isEnabled };
        } catch (error) {
            createNotification(
                'An error occurred while updating the seller DaQI editing setting.',
                'error'
            );
            throw error;
        }
    }
);
